(ns teamoesterreich.user-mode.landing.landing
  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
    ;usage (txt/txt :landing "Nachbarschaftshilfe-Kachel")
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.landing.app-panel.login :as login]
            [teamoesterreich.user-mode.landing.app-panel.prevent-card :as prevent-card]
            [teamoesterreich.user-mode.landing.app-panel.wanahelp-card :as wanahelp-card]
            [teamoesterreich.user-mode.landing.app-panel.warning-card :as warning-card]

            [teamoesterreich.user-mode.landing.landing-content :as landing-content]
            ))





(defn get-it []
  (let [!tom-id (r/cursor store/app-state [:actual-user :tom-id])]
    [mui/grid
     {:container true
      :direction "row-reverse"
      :justify   "space-around"
      :style     {:width "calc(100%-10px)"}
      }




     [mui/grid
      {:item true
       :md   4                                              ;medium screen
       :xs   12                                             ;mobile
       }

      [mui/grid
       {:container true
        :direction "column"
        :spacing   1
        :name      "ToeTodoButtons"
        :style     {:marginBottom "10px"}
        }
       [mui/grid
        {:item true
         }
        [login/get-it]]

       [mui/grid
        {:item true
         }
        [prevent-card/get-it]]

       [mui/grid
        {:item true
         }
        [warning-card/get-it]]

       [mui/grid
        {:item true
         }
        [wanahelp-card/get-it]]

       ]]

     [mui/grid
      {:item true
       :md   8                                              ;medium screen
       :xs   12                                             ;mobile
       }
      [landing-content/get-it]
      ]

     ]))